import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Slide, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import Bottom from "../../Bottom";
import { forwardRef, ReactElement, Ref, useEffect, useState } from "react";
import api from "../../../utils/api";

import { TransitionProps } from "@mui/material/transitions";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import tabbg from "../../../assets/images/tab_02.png"
import useHraStore from "../../../store/hraStores";

import ButtonBase from '@mui/material/ButtonBase';
import { responsiveFontSizes, styled } from '@mui/material/styles';
import reimg1 from "../../../assets/images/reimg1.png";
import reimg2 from "../../../assets/images/reimg2.png";
import reimg3 from "../../../assets/images/reimg3.png";

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Alert from '@mui/material/Alert';
import Paper from '@mui/material/Paper';


const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

// 새로고침 이미지 변경
const ImgArr = [reimg1, reimg3,];
const randomIndex = Math.floor(Math.random() * ImgArr.length);
const reTopImg = ImgArr[randomIndex];


// 모달창
const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: ReactElement<any, any>;
  },
  ref: Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});


const Hra = () => {

  const storeData: any = useHraStore();
  const navigate = useNavigate();

  useEffect(() => {
    getHraList();

    return () => {
      storeData.clear();
    }
  }, [])

  // 모달창
  const [open, setOpen] = useState(false);
  const handleOpen = (item: any) => {
    if (item.has_result) {
      if (!item.is_submitted) setTimeout(() => setOpen(true), 100)
      else navigate('result', { state: item.info.uid })
    }
  };
  const handleClose = () => {
    setOpen(false);
  }

  function getHraList() {
    let familyId: any = localStorage.getItem('ownerFamID');

    api.get(`customer/api/v2/surveys/families/${encodeURIComponent(familyId)}?survey_uid=hra`)
      .then(res => {
        // console.log(res);
        res.data.data.sort((a: any, b: any) => b.info.year - a.info.year);
        storeData.setHraList(res.data.data);
      })
      .catch(err => {
        console.log(err);
      });
  }

  function handleHraAnswer() {
    let famId: any = localStorage.getItem('ownerFamID');
    // navigate(`main?famId=${encodeURIComponent(famId)}&assigned_uid=${storeData.targetInfo.uid}&survey_uid=${storeData.targetSurvey.uid}`)

    const items = {
      family_id: famId,
      year: storeData.targetInfo.year,
      // assigned_uid: storeData.targetInfo.uid,
      // survey_uid: storeData.targetSurvey.uid,
    }

    navigate('answer', { state: items })
  }

  function targetLow(info: any, survey: any) {
    storeData.setTargetInfo(info);
    storeData.setTargetSurvey(survey);
  }

  // function handlePageChange(page: number) {
  //   storeData.setHraListParams('pageNum', page - 1);
  //   getHraList();
  // }
  const img = {
    display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
  }

  return (
    <Container sx={{ p: { xs: 0, md: 0 }, bgcolor: '#F6F6F6', pb: '60px !important', minHeight: '100vh', minWidth: 320 }}>
      <Box sx={{ bgcolor: '#FFEADF', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#ffeadf'} zIndex={999} maxWidth={'1200px'} >
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>
        <Grid container spacing={2} direction='row' sx={{ mt: 6, }}>
          <Grid container item xs sx={{ mx: 2, my: 5 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography className='topText' sx={{ fontSize: '1.5rem', color: '#FF7863', fontWeight: 900, textAlign: 'center'}}>
              뇌심혈관질환 발병위험도 평가
            </Typography>
            <Typography sx={{ fontSize: '1rem', color: '#EF8322', fontWeight: 500,  textAlign: 'center', mt: 2}} gutterBottom>
            뇌심혈관계질환 발병위험도평가
            </Typography>
          </Grid>
          
        </Grid>
      </Box>
      
      <Grid item>
        <Typography sx={{ display: 'block', fontSize: '16px', color: '#444', p: '30px 0 0 0', textAlign: 'center', mb: 2 }}>
        제출 된 응답은 수정이 <b>불가능</b>합니다.
        </Typography>
      </Grid>

      <TableContainer sx={{p: 2, boxSizing:'border-box',}}>
        <Paper sx={{ borderRadius: 5}}>
          <Table size="small" className="Cl_table" sx={{width: '100%', ml: 'auto', mr: 'auto', bgcolor :'#fff',borderRadius: 5}}>
            <TableHead>
              <TableRow sx={{'& th' :{p: 2, textAlign: 'center'}}}>
                <TableCell>연도</TableCell>
                <TableCell>제목</TableCell>
                <TableCell>참여</TableCell>
              </TableRow>
            </TableHead>
            <TableBody  sx={{'& td' :{px:1, py:2, textAlign: 'center',}, '& tr:last-child td' :{borderBottom: '0px', }}}>
              {
                storeData.hraList.length == 0
                  ? <TableRow>
                    <TableCell colSpan={3}>해당하는 설문이 없습니다.</TableCell>
                  </TableRow>
                  : storeData.hraList.map((item: any, idx: number) => {
                    return (
                      <TableRow key={idx} onClick={() => { handleOpen(item); targetLow(item.info, item.info.survey); }}>
                        <TableCell  sx={{width: 50}}>{item.info.year}</TableCell>
                        <TableCell sx={{textAlign: 'left!important'}}>
                          {item.info.survey.title}
                          {
                            <Typography component="span" color='gray' fontSize={12}><br />{item.has_result ? '' : `(검진 결과 등록이 필요합니다)`}</Typography>
                          }
                        </TableCell>
                        <TableCell>
                          {
                            item.has_result
                              ? (item.is_submitted ? <Typography sx={{width: 80, background: '#999', borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto', color:'#fff', fontSize: 14}}>완료</Typography> : <Typography sx={{background: '#0087ff', width: 80, borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto', color:'#fff', fontSize: 14}}>가능</Typography>)
                              : <Typography sx={{width: 80, color:'#fff', fontSize: 14, background: '#d10000', borderRadius: 20, padding: '2px 0px', ml: 'auto', mr:'auto'}}>불가</Typography>
                          }
                        </TableCell>
                      </TableRow>
                    )
                  })
              }
            </TableBody>
          </Table>
        </Paper>
      </TableContainer>

      {/* 모달창 */}
      {
        <Dialog
          open={open}
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          TransitionComponent={Transition}

        >
          <DialogContent >
            <Container>
              <Box sx={{ textAlign: 'center' }}>
                <ErrorOutlineIcon sx={{ fontSize: 40, color: '#db0000' }} />
                <Box>
                  <Typography sx={{ mt: 3, wordBreak:'keep-all'}}>{`[${storeData.targetInfo.year}년도 ${storeData.targetSurvey.title}]`}</Typography>
                  <Typography sx={{ mt: 1, fontWeight: "bold" }}>완료가 필요합니다.</Typography>
                </Box>
              </Box>
            </Container>
          </DialogContent>

          <DialogActions>
            <Box>
              <Button sx={{ color: '#fff', bgcolor: '#EF8322', '&:hover': { bgcolor: '#EF8322' } }} onClick={() => handleHraAnswer()}>확인</Button>
              <Button sx={{ color: '#fff', bgcolor: "#888", ml: 1, '&:hover': { bgcolor: '#555' } }} onClick={handleClose}>닫기</Button>
            </Box>
          </DialogActions>
        </Dialog>
      }

      <Bottom />
    </Container>
  )
}

export default Hra;